import { Injectable } from '@angular/core';

import * as GitHub from 'github-api';


@Injectable()
export class GithubManagerService {

 

  constructor() { 

    let gh = new GitHub({
      username: 'ludusrusso',
      password: 'Lundr1c0'
   });

   let me = gh.getUser();
   console.log(me);

   me.listStarredRepos((err, repos) => {
    console.log(repos);
  }); 
  
  }

}



// WEBPACK FOOTER //
// ./src/app/github-manager.service.ts